import { ChangeEvent, memo, useCallback, useEffect, useState, VFC } from "react";
import {
  Box,
  Button,
  Center,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  useDisclosure,
  Wrap,
  WrapItem
} from "@chakra-ui/react";

import { UserCard } from "../../organisms/user/UserCard";
import { useUser } from "../../../hooks/useUser";
import { UserDetailModal } from "../../organisms/modal/UserDetailModal";
import { useSelectUser } from "../../../hooks/useSelectUser";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { AddIcon, Search2Icon } from "@chakra-ui/icons";

export const Users: VFC = memo(() => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { getUsers,userAdd, userEdit, userDelete,userEnable,userDisable,userReset, loading,users } = useUser(onClose);
  const { onSelectUser, selectedUser } = useSelectUser();
  const { loginUser } = useLoginUser();

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => getUsers(), [getUsers]);

  const onClickUser = useCallback(
    (userName: string) => {
      onSelectUser({ userName, users, onOpen });
    },
    [users, onSelectUser, onOpen]
  );

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) =>{
    setSearchValue(e.target.value);
  }

  return (
    <>
      <Flex mx="5" my="2">
        ユーザーを選択してください。
      </Flex>
      <Flex mx="5">
        <InputGroup>
          <InputLeftElement
            pointerEvents='none'
            children={<Search2Icon color='gray.300' />}
          />
          <Input value={searchValue} placeholder="search userID (email)" onChange={onChangeSearch} />
        </InputGroup>
      </Flex>
      {loading ? (
        <Center h="50vh">
          <Spinner color="teal.200" />
        </Center>
      ) : (
        <>
          <Flex px={{ base: 4, md: 10 }} py={{ base: 2, md: 4 }}>
            <Button leftIcon={<AddIcon />} colorScheme='teal' variant='solid' onClick={()=>onClickUser("")}>
            新規登録
            </Button>        
          </Flex>
          <Wrap px={{ base: 4, md: 10 }} py={{ base: 1, md: 2 }}>
            {users.filter(obj => {
                    return searchValue === "" ||
                          obj.userName.indexOf(searchValue) >= 0
                  }).map((obj) => (
              <WrapItem key={obj.userName} mx="auto">
                <UserCard
                  userName={obj.userName}
                  firstName={obj.firstName}
                  lastName={obj.lastName}
                  confirmedStatus={obj.confirmedStatus}
                  enabled={obj.enabled}
                  role={obj.role}
                  onClick={onClickUser}
                />
              </WrapItem>
            ))}
          </Wrap>
        </>
      )}
      <UserDetailModal
        isOpen={isOpen}
        isAdmin={loginUser?.isAdmin}
        onInsert={userAdd}
        onUpdate={userEdit}
        onDelete={userDelete}
        onEnable={userEnable}
        onDisable={userDisable}
        onReset={userReset}
        onClose={onClose}
        user={selectedUser}
      />
    </>
  );
});
